module.exports = __webpack_public_path__ + "static/media/map.0eb9c401.png";